var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 154.88 154.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#f4ac74;}.cls-5{fill:#037f5b;}.cls-6{fill:#67bf8c;}.cls-7{fill:#fff;}.cls-8{fill:#f45558;}.cls-9{fill:#ffd54f;}.cls-10{fill:#80c692;}.cls-11{fill:#86c999;}.cls-12{fill:#cee3ae;}.cls-13{fill:#a3d3a2;}.cls-14{fill:#c0deaf;}.cls-15{fill:#d9defb;}.cls-16{fill:#c5cced;}.cls-17{fill:#36a7dc;}.cls-18{fill:#455a64;}.cls-19{fill:#2b3d42;}.cls-20{fill:#49a17d;}.cls-21{fill:#384c54;}.cls-22{fill:#5fb187;}.cls-2{stroke:#002a33;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.3,
    cy: 77.09,
    r: 71.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M149.63,156.02v-.02c2.71,0,5.42,.01,8.13,0,1.51-.01,2.64-.66,3.06-2.17,.41-1.49-.43-2.42-1.54-3.26-.45-.34-.89-.89-1.03-1.43-.57-2.19-2.08-3.3-4.29-2.85-.92,.19-1.44,.07-2.1-.68-2.94-3.34-7.59-2.39-9.18,1.78-.16,.42-.68,.94-1.1,1-2.69,.42-4.2,1.82-4.06,3.94,.15,2.33,1.76,3.67,4.51,3.7,2.53,.02,5.07,0,7.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.85,117.5c-.25-.13-.51-.26-.76-.39,.28-.1,.55-.2,.83-.3-.02,.23-.04,.46-.06,.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -0.66,
    y: 0.53,
    width: 153.88,
    height: 146.04
  }), /*#__PURE__*/React.createElement("g", {
    id: "_270"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M112.57,20.37v11.87H42.95v-11.87c0-2.07,1.68-3.74,3.74-3.74h62.13c2.07,0,3.74,1.68,3.74,3.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 42.95,
    y: 28.42,
    width: 69.61,
    height: 3.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M104.59,8.69v23.55H50.93V8.69c0-1.69,1.37-3.06,3.06-3.06h47.55c1.69,0,3.06,1.37,3.06,3.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 50.93,
    y: 28.42,
    width: 53.67,
    height: 3.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 33.56,
    y: 32.23,
    width: 88.4,
    height: 42.01,
    rx: 5.01,
    ry: 5.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M111.03,67.05v7.19H44.49v-7.19c0-2.45,1.99-4.43,4.43-4.43h57.66c2.45,0,4.43,1.99,4.43,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M107.61,67.83v6.41H47.91v-6.41c0-.78,.63-1.41,1.41-1.41h56.88c.78,0,1.41,.63,1.41,1.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 33.55,
    y: 56.91,
    width: 88.4,
    height: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M107.51,32.24v15.31c0,1.9-1.54,3.44-3.44,3.44H51.46c-1.9,0-3.44-1.54-3.44-3.44v-15.31h59.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 48.01,
    y: 36.16,
    width: 59.51,
    height: 3.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 48.01,
    y: 42.63,
    width: 59.51,
    height: 2.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.25,40.95c0,1.42-1.16,2.55-2.58,2.55s-2.55-1.13-2.55-2.55,1.16-2.55,2.55-2.55,2.58,1.13,2.58,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.25,48.17c0,1.42-1.16,2.55-2.58,2.55s-2.55-1.13-2.55-2.55,1.16-2.55,2.55-2.55,2.58,1.13,2.58,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M41.85,40.33c0,1.28-1.01,2.29-2.29,2.29s-2.29-1.01-2.29-2.29,1.04-2.29,2.29-2.29,2.29,1.04,2.29,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M41.85,46.86c0,1.28-1.01,2.29-2.29,2.29s-2.29-1.01-2.29-2.29,1.04-2.29,2.29-2.29,2.29,1.04,2.29,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "93.76 89.79 93.76 66.76 64.42 66.76 64.42 124.38 73.27 124.38 93.76 124.38 93.76 89.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M93.76,89.79h-2.69v28.75h0c-1.64,0-2.42,1.68-2.14,2.95h0s-15.64,.01-15.64,.01v2.87h20.49v-34.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.82,121.51h0c0-.79-.32-1.55-.88-2.1-.56-.55-1.33-.87-2.13-.87-.13,0-.26,.01-.39,.03v-45.7h.69v-.02c.09,0,.18,.01,.27,.01,1.6,0,2.93-1.33,2.93-2.93,0-.05,0-.09,0-.14h17.94s0,.09,0,.14c0,1.56,1.28,2.87,2.83,2.92h0v16.94h2.69v-23.03h-29.34v57.62h8.86v-2.87h-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M88.13,120.71h0s-16.25,.01-16.25,.01h-1.46c0-.79-.31-1.54-.86-2.08-.55-.55-1.3-.86-2.07-.86-.13,0-.25,.01-.38,.03v-44.95h-.69v45.7c.13-.02,.26-.03,.39-.03,.8,0,1.57,.31,2.13,.87,.56,.55,.88,1.31,.88,2.09h0s3.45,.01,3.45,.01h15.64c-.28-1.29,.5-2.97,2.14-2.97h0s0-.75,0-.75h0c-1.6,0-2.93,1.33-2.93,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M82.65,78.97c-.19,1.8-1.71,3.2-3.56,3.2s-3.37-1.4-3.56-3.2h-3.64v8.77c1.93-1.82,4.53-2.94,7.39-2.94,5.95,0,10.77,4.82,10.77,10.77s-4.82,10.77-10.77,10.77c-2.86,0-5.46-1.12-7.39-2.94v9.43h3.63c0-.09-.01-.18-.01-.28,0-1.98,1.61-3.59,3.59-3.59s3.59,1.61,3.59,3.59c0,.09,0,.19-.01,.28h8.4v-33.85h-8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M79.09,116.13c-1.89,0-3.43-1.46-3.57-3.31h-3.63v5.34c.07-.03,.15-.04,.23-.04h14.38c.38,0,.68,.29,.68,.64s-.3,.64-.68,.64h-14.38c-.08,0-.16-.02-.23-.04v1.35h16.25c0-1.61,1.33-2.94,2.93-2.94h0s0-4.96,0-4.96h-8.4c-.14,1.85-1.69,3.31-3.57,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M67.11,117.81c.13-.02,.25-.03,.38-.03,.77,0,1.52,.31,2.07,.86,.55,.55,.86,1.3,.86,2.07h0s1.46,.01,1.46,.01v-1.35c-.26-.09-.45-.32-.45-.6s.19-.51,.45-.6v-14.78c-2.08-1.96-3.38-4.74-3.38-7.83s1.3-5.86,3.38-7.83v-8.77h3.64c-.01-.13-.02-.26-.02-.39,0-1.98,1.61-3.59,3.59-3.59s3.59,1.61,3.59,3.59c0,.13,0,.26-.02,.39h8.41v-6.11h0c-1.55-.06-2.83-1.37-2.83-2.93,0-.05,0-.09,0-.14h-17.94s0,.09,0,.14c0,1.6-1.33,2.93-2.93,2.93-.09,0-.18,0-.27-.01v44.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M74.54,97.2c.46,.82,1.22,1.44,2.21,1.32,.46-.05,.8-.26,1.05-.54,.1-.25,.17-.53,.23-.8-1.16,.01-2.33,.02-3.49,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M83.18,93.86c-.06-.05-.11-.11-.17-.16-.04-.03-.12-.09-.14-.1-.08-.05-.17-.1-.26-.15h0s-.03,0-.05-.02c-.05-.01-.1-.03-.15-.04-.05,0-.12,0-.15,0-.03,0-.05,0-.05,0-.02,0-.04,.01-.07,.02-.04,.01-.16,.07-.17,.07-.02,.01-.04,.03-.07,.04-.03,.03-.14,.12-.16,.14-.18,.19-.17,.15-.33,.46-.06,.12-.12,.23-.17,.34,.79-.02,1.58-.04,2.36-.05-.02-.03-.04-.06-.06-.09-.21-.33-.08-.18-.35-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M68.51,95.57c0,3.08,1.3,5.86,3.38,7.83,1.93,1.82,4.53,2.94,7.39,2.94,5.95,0,10.77-4.82,10.77-10.77s-4.82-10.77-10.77-10.77c-2.86,0-5.46,1.12-7.39,2.94-2.08,1.96-3.38,4.74-3.38,7.83Zm5.93-1.02c1.38-.02,2.75-.02,4.13-.03,.2-.75,.47-1.47,.95-2.11,.13-.27,.29-.52,.47-.77,1.4-1.83,3.79-1.65,5.21,.07,.65,.79,1.02,1.7,1.15,2.66,.5,0,1.01-.01,1.51-.01,.65,0,.87,.67,.66,1.12,.32,.6,.04,1.53-.84,1.53-.41,0-.83,0-1.24,.01-.14,.84-.45,1.67-.94,2.44-.87,1.36-3.05,.1-2.17-1.27,.25-.39,.43-.72,.55-1.13-1.09,.02-2.19,.05-3.28,.07-.14,.74-.31,1.48-.63,2.18-1.54,3.34-6.2,2.77-7.67-.35-.25-.54-.43-1.11-.53-1.69-.29,.01-.58,.02-.87,.04-1.07,.06-1.25-1.31-.55-1.82-.01-.39,.23-.81,.74-.83,.25-.01,.51-.02,.76-.03,.08-.34,.18-.67,.31-1,.14-.36,.33-.7,.54-1.02,.56-1.34,1.61-2.33,3.25-2.31,.74,.01,1.03,.7,.89,1.25,.37,.75,.01,1.88-1.08,1.85,0,0-.34,.04-.29,.02-.48,.15-.81,.6-1.01,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M79.09,75c-1.98,0-3.59,1.61-3.59,3.59,0,.13,0,.26,.02,.39,.19,1.8,1.71,3.2,3.56,3.2s3.37-1.4,3.56-3.2c.01-.13,.02-.26,.02-.39,0-1.98-1.61-3.59-3.59-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M79.09,116.13c1.89,0,3.43-1.46,3.57-3.31,0-.09,.01-.18,.01-.28,0-1.98-1.61-3.59-3.59-3.59s-3.59,1.61-3.59,3.59c0,.09,0,.19,.01,.28,.14,1.85,1.69,3.31,3.57,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.52,92.4c-.48,.64-.75,1.36-.95,2.11,.1,0,.19,0,.29,0,.15-.73,.33-1.44,.66-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.73,93.38c1.09,.02,1.44-1.1,1.08-1.85-.1,.37-.39,.67-.89,.67-1.15-.02-1.66,1.24-1.82,2.35,.11,0,.23,0,.34,0,.2-.55,.53-.99,1.01-1.14-.06,.02,.28-.02,.29-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.54,97.2c1.16-.01,2.33-.02,3.49-.03-.06,.27-.13,.55-.23,.8,.44-.49,.64-1.24,.77-1.93-1.48,.02-2.97,.02-4.45,.04,.08,.38,.22,.77,.42,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.85,95.88c-.5,0-1.01,0-1.51,.01-.12,.88-.44,1.75-.93,2.53-.66,1.04-2.32,.08-1.65-.97,.3-.48,.53-.99,.65-1.53-1.3,.03-2.59,.06-3.89,.08-.1,.6-.22,1.2-.44,1.77-.57,1.44-1.67,2.61-3.32,2.65-1.64,.04-3.23-.94-3.97-2.41-.27-.54-.45-1.19-.54-1.89-.39,.01-.79,.03-1.18,.05-.48,.03-.73-.33-.74-.7-.7,.51-.52,1.88,.55,1.82,.29-.01,.58-.03,.87-.04,.1,.58,.28,1.15,.53,1.69,1.47,3.11,6.13,3.69,7.67,.35,.32-.7,.49-1.43,.63-2.18,1.09-.03,2.18-.05,3.28-.07-.12,.41-.3,.74-.55,1.13-.88,1.37,1.3,2.63,2.17,1.27,.49-.76,.81-1.59,.94-2.44,.41,0,.83,0,1.24-.01,.89,0,1.17-.94,.84-1.53-.11,.23-.33,.41-.66,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.4,94.12c.17-.31,.15-.27,.33-.46,.02-.02,.13-.11,.16-.14,.02-.01,.04-.03,.07-.04,.02,0,.13-.06,.17-.07,.03,0,.05-.02,.07-.02,0,0,.02,0,.05,0,.03,0,.11,0,.15,0,.05,.01,.1,.03,.15,.04,.02,0,.04,.01,.05,.01h0c.09,.04,.17,.1,.26,.15,.02,.01,.1,.07,.14,.1,.06,.05,.11,.1,.17,.16,.27,.27,.14,.12,.35,.45,.02,.03,.04,.06,.06,.09,.28,0,.56-.01,.83-.02-.02-.1-.05-.2-.08-.3-.23-.75-.79-1.62-1.52-1.83-.31-.09-.56-.1-.85,.08-.39,.25-.65,.67-.83,1.08-.15,.34-.26,.68-.34,1.04,.14,0,.28,0,.43-.01,.05-.11,.11-.22,.17-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.67,92.59c-.21,.32-.4,.66-.54,1.02-.13,.33-.23,.66-.31,1,.13,0,.26-.01,.39-.02,.05-.7,.21-1.39,.46-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M75.92,92.2c.5,0,.79-.3,.89-.67,.14-.55-.15-1.24-.89-1.25-1.64-.02-2.69,.97-3.25,2.31-.26,.62-.41,1.3-.46,2-.13,0-.26,.01-.39,.02-.25,.01-.51,.02-.76,.03-.5,.03-.75,.44-.74,.83,.01,.37,.26,.72,.74,.7,.39-.02,.79-.04,1.18-.05,.09,.7,.27,1.35,.54,1.89,.74,1.47,2.33,2.45,3.97,2.41,1.66-.04,2.76-1.21,3.32-2.65,.22-.57,.34-1.17,.44-1.77,1.3-.03,2.59-.06,3.89-.08-.12,.54-.35,1.05-.65,1.53-.67,1.04,.99,2,1.65,.97,.49-.77,.81-1.64,.93-2.53,.5,0,1.01-.01,1.51-.01,.33,0,.55-.18,.66-.41,.21-.45,0-1.12-.66-1.12-.5,0-1.01,0-1.51,.01-.13-.95-.5-1.87-1.15-2.66-1.42-1.72-3.81-1.9-5.21-.07-.19,.24-.34,.5-.47,.77-.33,.66-.51,1.38-.66,2.1-.1,0-.19,0-.29,0-1.38,.02-2.75,.02-4.13,.03-.11,0-.23,0-.34,0,.16-1.11,.67-2.37,1.82-2.35Zm1.88,5.77c-.26,.29-.59,.49-1.05,.54-.99,.12-1.75-.5-2.21-1.32-.2-.35-.34-.74-.42-1.12,1.48-.02,2.97-.02,4.45-.04-.13,.69-.33,1.44-.77,1.93Zm3.34-4.55c.19-.42,.44-.83,.83-1.08,.29-.19,.55-.17,.85-.08,.72,.21,1.28,1.08,1.52,1.83,.03,.1,.05,.2,.08,.3-.28,0-.56,0-.83,.02-.79,.02-1.58,.04-2.36,.05-.14,0-.28,0-.43,.01,.09-.35,.19-.7,.34-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.43,118.77c0,.28,.19,.51,.45,.6,.07,.03,.15,.04,.23,.04h14.38c.38,0,.68-.29,.68-.64s-.3-.64-.68-.64h-14.38c-.08,0-.16,.02-.23,.04-.26,.09-.45,.32-.45,.6Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.44,
    cy: 77.44,
    r: 73.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ5);
export default __webpack_public_path__ + "static/media/q5.fb6d1bc63d08b2020794decbb9e10211.svg";
export { ForwardRef as ReactComponent };